import { xml } from "@xmpp/client";
import debug from "src/modules/debug-logger";
import { store } from "src/store/store";
import { getStatus } from "src/duck/selectors";
import * as actions from "src/duck/actions";

const ONE_MINUTE = 60 * 1000;
const TIMEOUT = 20 * 1000;

export class PingService {
  get status() {
    const state = store.getState();
    const appStatus = getStatus(state);
    return appStatus;
  }

  initialize = ({ xmpp }) => {
    this.caller = xmpp.iqCaller;
    this.start();
  };

  start = (
    { pingEvery, timeout } = { pingEvery: ONE_MINUTE, timeout: TIMEOUT }
  ) => {
    if (!this.caller) return;
    this.pingInterval = setInterval(async () => {
      try {
        debug.xmpp("About to send ping to XMPP server");
        const response = await this.caller.request(
          xml("iq", { type: "get" }, xml("ping", "urn:xmpp:ping")),
          timeout
        );
        debug.xmpp("XMPP ping response: ", response);
        if (!response) {
          throw new Error("Didn't recieve response from xmpp server");
        }
      } catch (err) {
        debug.xmpp("Ping Service error: ", err);
        this.stop();
        store.dispatch(actions.connectionLost());
      }
    }, pingEvery);
  };

  stop = () => {
    clearInterval(this.pingInterval);
    this.pingInterval = null;
  };
}
